// Meta Pixel bootstrap — must only be called AFTER analytics consent is granted.
// Module-level flag ensures init runs at most once per page load.

const PIXEL_ID = '1656645685879357';

let _initialized = false;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type FbqFn = ((...args: any[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: FbqFn;
  loaded: boolean;
  version: string;
};

interface WindowWithFbq extends Window {
  fbq?: FbqFn;
  _fbq?: FbqFn;
}

export function initMetaPixel(): void {
  if (typeof window === 'undefined' || _initialized) return;
  _initialized = true;

  const w = window as unknown as WindowWithFbq;

  if (!w.fbq) {
    // Build the fbq stub so queued calls are held until fbevents.js loads.
    // Matches Meta's official snippet pattern.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const stub = function (...args: any[]) {
      if (stub.callMethod) {
        stub.callMethod(...args);
      } else {
        stub.queue.push(args);
      }
    } as FbqFn;

    stub.push = stub;
    stub.loaded = true;
    stub.version = '2.0';
    stub.queue = [];
    stub.callMethod = undefined;

    w.fbq = stub;
    if (!w._fbq) w._fbq = stub;
  }

  w.fbq('init', PIXEL_ID);
  w.fbq('track', 'PageView');

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
}

export function trackMetaLead(): void {
  if (typeof window === 'undefined') return;
  const w = window as unknown as WindowWithFbq;
  if (!w.fbq) return;
  w.fbq('track', 'Lead');
}

export function isMetaPixelInitialized(): boolean {
  return _initialized;
}

export function _resetForTesting(): void {
  _initialized = false;
}
